<main>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Privacy Policy</h1>
        <p>
          This Privacy Policy (“<strong>Policy</strong>”) describes the privacy
          practices of Intel 471, Inc. (“<strong>Intel 471</strong>”,
          “<strong>we</strong>”, “<strong>us</strong>” or
          “<strong>our</strong>”), the types of information that we collect, and
          the ways in which we use such information.&nbsp; By accessing any of
          our websites that reference or link to this Policy, including [<em
            ><a href="https://hunter.cyborgsecurity.io"
              >hunter.cyborgsecurity.io</a
            ></em
          >] (each, a “<strong>Site</strong>” and collectively, the
          “<strong>Sites</strong>”), or by using any of our products or services
          made available via the Sites (collectively,
          “<strong>Services</strong>”), you agree to be bound by the terms and
          conditions of this Policy.
        </p>
        <p>
          We may update this Policy from time to time in our sole discretion by
          posting an updated version of this Policy to one or more of the
          Sites.&nbsp; It is your responsibility to review this Policy for any
          changes each time that you access any of the Sites or use any of the
          Services, and you are bound by such changes. &nbsp;Use of the Sites or
          Services by you following any changes to this Policy constitutes your
          acceptance of the Policy, as modified.
        </p>
        <p><strong>Information Collection and Use</strong></p>
        <p>
          In connection with the Sites and Services, we may collect and use the
          following categories of information:
        </p>
        <ul>
          <li>information regarding your use of the Sites and Services;</li>
          <li>
            information that you provide for the purpose of contacting you,
            including your name and email address; and
          </li>
          <li>
            any other information that you provide or make available to us.
          </li>
        </ul>
        <p>
          You may choose not to provide certain information to us, but as a
          result you may not be able to take advantage of some of the features
          of the Sites or Services.
        </p>
        <p>
          We may also collect general, non-personal, statistical information
          about the use of the Sites and Services automatically, such as how
          many visitors visit a specific website page, how long they stay on
          that page, the hyperlinks users click, or similar information.&nbsp;
          We collect this information by using cookies, log files and other
          similar technologies (as described further below).&nbsp; This
          information represents a generic overview of our users and allows us
          to modify the Sites and Services based on user traffic and
          behavior.&nbsp; We collect this information in order to help enhance
          the Sites and Services, and improve the user experience.
        </p>
        <p><strong>Log Data</strong></p>
        <p>
          Like many other websites, the Sites and Services make use of log
          files. The information inside the log files includes internet protocol
          (IP) addresses, type of browser, browser version, Internet Service
          Provider (ISP), date/time stamp, referring/exit pages, and number of
          clicks to analyze trends, administer the Site, track a user’s movement
          around the Sites and Services, and gather demographic information.
        </p>
        <p><strong>Cookies</strong></p>
        <p>
          Cookies are files with a small amount of data that is sent to your
          browser from a website’s servers and stored on your computer’s hard
          drive which often includes an anonymous unique identifier. Cookies do
          not identify specific users, only a user’s device.&nbsp; We use
          cookies to track and record user session information, and to collect
          information to improve our Sites and Services. &nbsp;You may set your
          browser to notify you when you receive a new cookie or to disable
          cookies.&nbsp; However, if you choose to refuse our cookies, you may
          not be able to use some portions of our Sites or Services.
        </p>
        <p><strong>Use of Collected Information</strong></p>
        <p>We may use the information that we collect in order to:</p>
        <ul>
          <li>administer the Sites;</li>
          <li>personalize the Sites or Services for you;</li>
          <li>enable your access to and use of the Services;</li>
          <li>improve the Sites or Services;</li>
          <li>
            conduct internal business analysis or other business purposes; and
          </li>
          <li>send you communications, including marketing communications.</li>
        </ul>
        <p>We do not disclose your information to third parties, except:</p>
        <ul>
          <li>when we have your permission to make the disclosure;</li>
          <li>
            where the disclosure is necessary for the purpose for which the
            information was obtained;
          </li>
          <li>
            to our third party service providers in order to provide services to
            us (including marketing communications, email delivery, and business
            operations); or
          </li>
          <li>as otherwise disclosed in this Policy.</li>
        </ul>
        <p>
          We may also disclose your information where permitted by applicable
          law or when the disclosure is necessary, in our sole discretion, for
          the establishment or maintenance of legal claims or legal compliance,
          to satisfy any law, regulation, subpoena or government request, or in
          connection with litigation.
        </p>
        <p>
          In the event we are acquired by, or merge or consolidate into, another
          entity, or if there is a sale of our assets (including in bankruptcy),
          your information may be transferred to the entity acquiring us or our
          assets or that survives the merger or consolidation.&nbsp; You
          acknowledge and agree that in the foregoing circumstances, your
          information may be disclosed to such third party.
        </p>
        <p><strong>Security</strong></p>
        <p>
          We use security measures that we (in our sole discretion) deem
          appropriate for the type of information that is provided by you, and
          to comply with any applicable legal requirements. However, since no
          method of electronic storage is 100% secure, we cannot guarantee the
          absolute security of the information stored.&nbsp; We also cannot
          guarantee that information you supply will not be intercepted while
          being transmitted to us over the Internet.
        </p>
        <p><strong>Links to Other Sites</strong></p>
        <p>
          Our Sites and Services may contain links to other websites or
          applications (each, a “<strong>Third Party Site</strong>”).&nbsp; We
          do not control or endorse any Third Party Site, and such Third Party
          Sites are not operated by us. We strongly advise you to review the
          privacy policy of each Third Party Site that you visit. We have no
          control over, and assume no responsibility for the content, privacy
          policies, or practices of any Third Party Site, and you agree that
          your use of a Third Party Site is at your own risk.
        </p>
        <p><strong>Use by Minors</strong></p>
        <p>
          We do not knowingly collect information from children under the age of
          13. &nbsp;If we discover that a child under 13 has provided us with
          information, we will make commercially reasonable efforts to delete
          this information from our servers.
        </p>
        <p><strong>California Do Not Track Disclosure</strong></p>
        <p>
          At this time, we do not respond to browser ‘Do Not Track’ signals.
        </p>
        <p><strong>International Users</strong></p>
        <p>
          Our Sites and Services are intended for individuals located in the
          United States. &nbsp;If you are located outside of the United States
          and access the Sites or Services or submit your information to us, you
          do so at your own risk and choice. &nbsp;United States law may not
          offer the same privacy protections as the law of your
          jurisdiction.&nbsp; If you visit our Sites or use our Services, or
          contact us, from outside of the United States, please be advised that
          (a) any information you provide to us or that we automatically collect
          will be transferred to the United States; and (b) that by using our
          Sites or Services or submitting information, you explicitly authorize
          its transfer to and subsequent processing in the United States in
          accordance with this Policy and United States law.
        </p>
        <p><strong>Contact Us</strong></p>
        <p>
          If you have any questions about this Policy, do not hesitate to
          contact us at:
        </p>
        <address>
          1209 N. Orange Street <br />
          Wilmington, DE. 19801
        </address>
        <a href="mailto:info@intel471.com">info&#64;intel471.com</a>
      </div>
    </div>
  </div>
</main>
